{
  "nav": {
    "home": "Início",
    "scouting": "Observação",
    "reports": "Relatórios",
    "settings": "Configurações"
  },
  "settings": {
    "language": "Idioma",
    "languageDescription": "Escolha o idioma usado em todo o aplicativo.",
    "save": "Salvar"
  },
  "reports": {
    "title": "Relatórios de observação",
    "empty": "Ainda não há relatórios",
    "generateSummary": "Gerar resumo",
    "translationUnavailable": "Tradução indisponível. Exibindo o relatório original.",
    "retryTranslation": "Tentar novamente",
    "matchesHeading_one": "Partida:",
    "matchesHeading_other": "Partidas:",
    "matchLineHome": "vs {{opponent}} em {{date}}",
    "matchLineAway": "em {{opponent}} em {{date}}",
    "matchLineNeutral": "{{opponent}} em {{date}}",
    "editorTitle": "Editar relatório de observação",
    "untitled": "Relatório",
    "authorSelf": "Você",
    "sharedBadge": "Compartilhado",
    "shareAction": "Compartilhar",
    "sharedAction": "Compartilhado",
    "back": "Voltar",
    "editedBy": "Editado por",
    "createdBy": "Criado por",
    "translate": "Traduzir",
    "translating": "Traduzindo...",
    "showOriginal": "Ver original",
    "download": "Baixar",
    "downloading": "Baixando...",
    "edit": "Editar",
    "archive": "Arquivar"
  },
  "language": {
    "control": "Idioma",
    "selectTitle": "Selecionar idioma",
    "change": "Alterar idioma",
    "changeCurrent": "Alterar idioma, atualmente {{language}}",
    "changeStranded": "Alterar idioma. Seu idioma salvo {{code}} não é mais oferecido, então {{language}} é usado no lugar.",
    "generate": "Gerar · {{language}}",
    "generateAccessibility": "Idioma do resumo gerado",
    "saveDefault": {
      "idle": "Salvar como meu idioma padrão",
      "saving": "Salvando…",
      "saved": "Salvo como seu idioma padrão",
      "alreadyDefault": "Este já é seu idioma padrão",
      "error": "Não foi possível salvar — toque para tentar novamente",
      "warning": "Aplica-se apenas a este resumo. Salve como seu idioma padrão ou você precisará gerá-lo novamente da próxima vez.",
      "errorAccessible": "{{label}}. {{reason}}",
      "failed": "Não foi possível salvar seu idioma padrão. Tente novamente."
    }
  }
}
